import PropTypes from 'prop-types'
import { useTheme } from 'react-admin'
import { Box, Grid, Typography } from '@mui/material'

export default function ComponentWrapper({ title, children }) {
  const [theme] = useTheme()

  return (
    <Grid item xs={12} lg={6}>
      <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
        {title}
      </Typography>
      <Box
        sx={{
          backgroundColor: theme.palette.background.card,
          border: '1px solid rgba(0, 0, 0, 0.12)',
        }}
      >
        {children}
      </Box>
    </Grid>
  )
}

ComponentWrapper.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
}
